import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import type { TripListStatusValue } from '../components/ListView/tripListTypes'

// Deliberately not getTripListStatusLabel (react-intl) -- activity displayText is LLM-context only,
// never customer-facing, and stays English regardless of locale, same rule already applied to
// every other kind in this family (e.g. the map explore-category label). Exported so
// buildListFilterChangedActivityEntry's status dimension can reuse it instead of passing the raw
// TripListStatusValue ('NOT_BOOKED' etc.) straight through.
export function englishStatusLabel(value: TripListStatusValue): string {
  if (value === 'BOOKED') return 'Booked'
  if (value === 'IDEA') return 'Idea'
  return 'Not booked'
}

// occurredAt is the caller's timestamp, not one taken here -- this is only ever built from a
// useMutation onSuccess callback, which fires after the update request round-trips, so a
// timestamp taken here would report when that finished, not when the customer picked the status.
export function buildItemStatusChangedActivityEntry(
  title: string,
  previousStatus: TripListStatusValue,
  newStatus: TripListStatusValue,
  occurredAt: string,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'item_status_changed',
    label: 'Changed itinerary item status',
    displayText: boundActivityDisplayText(`${title}: ${englishStatusLabel(previousStatus)} → ${englishStatusLabel(newStatus)}`),
    sourcePath: 'trip_planner.list.status_change',
    dataClassification: 'personalised_surface',
    occurredAt,
  }
}
